<template>
  <div>
    <b-card title="Banner" header-tag="header" footer-tag="footer">

      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <!-- <div class="alert alert-warning">
        Não se esqueça de salvar suas alterações
      </div> -->

      <div class="row">
        <b-form-group class="col-12 col-lg-6"
          label="Imagem"
          label-for="media">

          <single-media-uploader
            name="file"
            @success="handleUploadMedia"
            :url="mediaUrl"
            placeholder="static/img/defaults/upload.png"
            :source="mediaInstance">

            <div slot="mask" :class="`w-100 banner-data-preview text-${form.alignment}`">
              <div class="heading-text">
                {{ form.heading }}
              </div>

              <div class="subheading-text">
                {{ form.subheading }}
              </div>

              <div v-if="form.anchor_label" class="anchor-text">
                <b-button size="sm" variant="outline-secondary">
                  {{ form.anchor_label }}
                </b-button>
              </div>
            </div>
          </single-media-uploader>
        </b-form-group>

        <div class="col-12 col-lg-6">
          <div class="row">
            <b-form-group class="col-12"
              label="Título"
              label-for="heading"
              description="(Obrigatório)">

              <b-form-input id="heading"
                v-model="form.heading"
                placeholder="Titulo"
                required
                :class="{
                  'is-invalid': submitted && form.errors.has('heading'),
                  'is-valid': submitted && !form.errors.has('heading')
                }">
              </b-form-input>
            </b-form-group>

            <b-form-group class="col-12"
              label="Subtítulo"
              label-for="subheading">

              <b-form-input id="subheading"
                v-model="form.subheading"
                placeholder="Subtítulo"
                :class="{
                  'is-invalid': submitted && form.errors.has('subheading'),
                  'is-valid': submitted && !form.errors.has('subheading')
                }">
              </b-form-input>
            </b-form-group>

            <b-form-group class="col-12"
              label="Alinhamento"
              label-for="alignment">
              <b-form-radio-group id="alignment" v-model="form.alignment" name="alignment">
                <b-form-radio value="left">Esquerda</b-form-radio>
                <b-form-radio value="center">Centro</b-form-radio>
                <b-form-radio value="right">Direita</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group class="col-12">
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-6 alpha">
                    <label>Texto do botão</label>
                    <b-form-input id="anchor_label"
                      v-model="form.anchor_label"
                      placeholder="Mais"
                      :class="{
                        'col': true,
                        'is-invalid': submitted && form.errors.has('anchor_label'),
                        'is-valid': submitted && !form.errors.has('anchor_label')
                      }">
                    </b-form-input>
                  </div>
                  <div class="col-lg-6 omega">
                    <label>Abrir em</label>

                    <multiselect v-model="selectedTarget"
                      @select="updateForm('anchor_target', arguments[0])"
                      :showLabels="false"
                      :allowEmpty="false"
                      :options="targets"
                      label="text"
                      placeholder="Selecione"
                      track-by="id">
                    </multiselect>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 alpha omega">
                <br/>
                <label>Link</label>
                <b-form-input id="anchor_url"
                  v-model="form.anchor_url"
                  placeholder="http://..."
                  :class="{
                    'col-12': true,
                    'is-invalid': submitted && form.errors.has('anchor_url'),
                    'is-valid': submitted && !form.errors.has('anchor_url')
                  }">
                </b-form-input>
              </div>
            </b-form-group>
          </div>
        </div>
      </div>

      <slot name="footer"></slot>
    </b-card>
  </div>
</template>

<script>
import { isEmpty, get, set } from 'lodash'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
          media: []
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      media: {},

      selectedTarget: null,
      targets: [
        { id: 1, text: 'Mesma Janela' },
        { id: 2, text: 'Nova Janela' }
      ],

      empty: {
        heading: '',
        subheading: '',
        media_ids: [],
        alignment: 'left',
        anchor_label: '',
        anchor_target: 0,
        anchor_url: '',
        status: true
      }
    }
  },

  watch: {
    '$props': {
      handler: function (newProps, oldProps) {
        if (!get(newProps, 'form.anchor_target', false)) {
          this.selectedTarget = null
        }
      },
      deep: true
    },

    selectedTarget () {
      set(this.form, 'anchor_target', get(this.selectedTarget, 'id', null))
    }
  },

  computed: {
    mediaUrl () {
      return this.http.routes.uploadMedia(this.instance.id)
    },

    mediaInstance () {
      if (!isEmpty(this.media)) {
        return this.media
      }

      if (!isEmpty(this.instance.media)) {
        return this.instance.media[0]
      }

      return {}
    }
  },

  methods: {
    updateForm (path, value) {
      set(this.form, path, value ? value.id : null)
    },

    handleUploadMedia (file, response, progress) {
      // 1. we will set the new media id on the form for latter process
      this.form.media_ids = [response.id]

      // 2. Let's set the media on the source for the upload field
      this.media = response
    }
  },

  created () {
    const self = this

    self.form.withData(self.instance.id ? self.instance : self.empty)
      .setInitialValues(self.instance.id ? self.instance : self.empty)

    self.selectedTarget = get(self.form, 'anchor_target', false)
      ? self.targets.find((o) => parseInt(o.id, 10) === parseInt(get(self.form, 'anchor_target', 0), 10))
      : self.targets[0]
  }
}
</script>

<style lang="sass">
  .banner-data-preview
    position: absolute
    padding: 1em 2em 1em 2em;
    color: #fff

    .heading-text
      margin-top: 6vh
      font-size: 22px

    .subheading-text
      font-size: 16px

    .anchor-text .btn-outline-secondary
      margin-top: 2vh
      background-color: #fff

  .media-preview.img-fluid
    max-height: 30vh
</style>



// WEBPACK FOOTER //
// src/components/forms/Bl/Banner.vue